import { useStore } from '../../store/useStore';
import { DialogUI } from './DialogUI';
import { QuestTracker } from './QuestTracker';
import { QuestLog } from '../canvas/ui/QuestLog';
import { AchievementToast } from '../canvas/ui/AchievementToast';
import { InventoryUI } from './InventoryUI';
import { Minimap } from './Minimap';
import { PlayerStatus } from './PlayerStatus';
import { useEffect } from 'react';
import { isMobile } from '../../utils/isMobile';
import { Joystick } from './Joystick';
import { ShopUI } from './ShopUI';
import { CooldownIndicator } from './CooldownIndicator';
import { PauseMenu } from './PauseMenu';

export const UIOverlay = () => {
    const { toggleInventory, gameStarted } = useStore();

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const el = document.activeElement as HTMLElement | null;
            if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) return;
            if (e.key.toLowerCase() === 'i') {
                toggleInventory();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [toggleInventory]);

    if (!gameStarted) return null;

    return (
        <div className="ui-layer" style={{
            pointerEvents: 'none',
            position: 'absolute',
            inset: 0,
            padding: '20px',
            fontFamily: "'Inter', sans-serif",
            zIndex: 1000
        }}>
            {/* Crosshair - Lower z-index to not obstruct UI */}
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
                display: gameStarted ? 'block' : 'none',
                zIndex: 500  // Below most UI (UIOverlay is 1000), but visible
            }}>
                <svg width="32" height="32" viewBox="0 0 32 32" style={{ filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.8))' }}>
                    <circle cx="16" cy="16" r="12" fill="none" stroke="#0f0" strokeWidth="1" opacity="0.6" />
                    <line x1="16" y1="8" x2="16" y2="24" stroke="#0f0" strokeWidth="1" opacity="0.7" />
                    <line x1="8" y1="16" x2="24" y2="16" stroke="#0f0" strokeWidth="1" opacity="0.7" />
                </svg>
            </div>
            <DialogUI />
            <Minimap />
            <PlayerStatus />
            <QuestTracker />
            <AchievementToast />
            {/* <QuestLog /> -- To be toggled by keybind later */}
            <InventoryUI />
            <ShopUI />
            <CooldownIndicator />
            {isMobile() && <Joystick />}
            <PauseMenu />
        </div>
    );
};
